import { type FC, memo, useState } from 'react';

import { getSelectedProfessions } from 'utils/profRoles';

import useProfRolesTranslations, { TranslationNamespaces } from 'hooks/translation/useProfRolesTranslations';
import useTrls from 'hooks/translation/useTrls';

import InfoRow from 'components/CampaignCard/CampaignInfo/Targetings/InfoRow/InfoRow';
import AdditionalProfessionsModal from 'components/CampaignCard/CampaignInfo/Targetings/Professions/AdditionalProfessionsModal';
import { WithAdditional } from 'components/CampaignCard/CampaignInfo/Targetings/utils';

import { selectProfessions } from 'store/autoReducers';
import { useSelector } from 'store/utils';

import styles from 'components/CampaignCard/CampaignInfo/Targetings/Professions/Professions.module.less';

interface Props {
    professionalRoles: Array<string>;
}

const AdProfessions = WithAdditional(InfoRow);

const Professions: FC<Props> = ({ professionalRoles }) => {
    const translations = useProfRolesTranslations(TranslationNamespaces.Campaign, true);
    const professions = useSelector((state) => selectProfessions(state));
    const [showModal, setShowModal] = useState(false);
    const trl = useTrls();

    const [firstProfession, allProfessions] = getSelectedProfessions(professions, professionalRoles);
    const professionNames = allProfessions.map((item) => item.name);

    if (!firstProfession) return null;

    return (
        <div className={styles.professions}>
            <AdProfessions
                titleTrl={trl('campaign.targetings.professions.item')}
                onAdditionalTextClick={() => setShowModal(true)}
                items={professionNames}
            />

            <AdditionalProfessionsModal
                visible={showModal}
                setVisible={setShowModal}
                items={professionNames}
                titleTrl={translations.title}
                closeTrl={translations.close}
            />
        </div>
    );
};

export default memo(Professions);
